import { render, staticRenderFns } from "./CourseShowService.vue?vue&type=template&id=38422165&scoped=true&"
import script from "./CourseShowService.vue?vue&type=script&lang=js&"
export * from "./CourseShowService.vue?vue&type=script&lang=js&"
import style0 from "./CourseShowService.vue?vue&type=style&index=0&id=38422165&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38422165",
  null
  
)

export default component.exports